import ChatLock from '@assets/images/common/icon/channel/lock.svg';
import OpenSidebarIcon from '@assets/images/common/icon/channel/open_sidebar.svg';
import ProhibitedIcon from '@assets/images/common/icon/channel/prohibited.png';
import { Channel } from '@src/api/shared/community/channelApiClient';
import Button from '@src/ui/elements/button/Button';
import { Emoji } from 'emoji-picker-react';
import React from 'react';

interface Props {
  channel: Channel;
  inviteLoading: boolean;
  inviteSent: boolean;
  onInviteRequest: () => void;
  toggleMobileSidebar: () => void;
}

const ChannelAccessDeniedLoggedIn: React.FC<Props> = ({
  channel,
  inviteLoading,
  inviteSent,
  onInviteRequest,
  toggleMobileSidebar,
}) => (
  <main className='h-full'>
    <div className='hidden items-center justify-between lg:flex'>
      <div className='flex h-[60px] w-full items-center'>
        <button
          className='hidden size-[32px] flex-[0_0_auto] place-items-center lg:grid'
          onClick={toggleMobileSidebar}
          data-setting-menu=''
        >
          <img
            src={OpenSidebarIcon}
            alt=''
            width={16}
            height={16}
            className='size-[16px]'
          />
        </button>
        <div className='flex w-full items-center lg:w-[calc(100%-32px)]'>
          <div className='flex w-[calc(100%-60px)] items-center gap-2 lg:items-center'>
            <h1 className='flex max-w-[60%] items-center gap-2 truncate text-[18px] font-bold lg:max-w-full lg:text-[16px]'>
              <Emoji
                unified={channel?.emoji || ''}
                size={20}
                key={`emoji-header-${channel?.emoji}`}
              />
              <span className='truncate'>{channel?.name}</span>
            </h1>
            <img
              src={ChatLock}
              alt=''
              width={20}
              height={20}
              className='size-[20px] object-contain'
            />
          </div>
        </div>
      </div>
    </div>
    <div className='grid h-full place-items-center overflow-scroll bg-gray-10 xl:h-[calc(100vh-61px)] md:h-[calc(100vh-121px)]'>
      <div className='w-full px-6 md:max-w-[390px]'>
        <img
          className='mx-auto mb-8 md:mb-3'
          width={104}
          height={104}
          src={ProhibitedIcon}
          alt=''
        />
        <h1 className='mb-6 text-center text-xl font-semibold leading-loose md:text-lg'>
          このチャンネルはメンバー限定です
        </h1>
        <div>
          <p className='mb-[42px] text-center text-sm md:mb-[28px]'>
            管理者にチャンネルへの招待を依頼してください。
          </p>
          <div className='mx-auto mb-3 w-[360px] md:w-full'>
            <Button
              size='m'
              fullRounded
              fullWidth
              disabled={inviteLoading || inviteSent}
              onClick={onInviteRequest}
            >
              管理者へ招待を依頼する
            </Button>
          </div>
          {!(inviteLoading || inviteSent) && (
            <div className='text-center text-sm'>テナント管理者にメールが送信されます</div>
          )}
        </div>
      </div>
    </div>
  </main>
);

export default ChannelAccessDeniedLoggedIn;
